module.exports = __webpack_public_path__ + "static/media/Dysmate2_compressed.7d174aa3.pdf";